import { FormInstance } from "antd";
import { SiteReadable as Site } from "../../../services/client";
import OptimizationConfigurationForm from "./OptimizationConfigurationForm/OptimizationConfigurationForm";

type StepFourProps = {
  site?: Site;
  form: FormInstance;
};

export const StepFour: React.FC<StepFourProps> = ({ form }) => {
  return <OptimizationConfigurationForm form={form} markFormDirty={null} />;
};
